import { render, staticRenderFns } from "./empty_rule_approvers.vue?vue&type=template&id=3f4d6092"
import script from "./empty_rule_approvers.vue?vue&type=script&lang=js"
export * from "./empty_rule_approvers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports